import { AppContext } from "components/app/RemExprertProvider";
import { applyFormat } from "components/ui/ui-helpers";
import { useContext } from "react";

const DetailCotisationsCavp = (props) => {
  const { DetailCotisations, DetailCSG, TotalChargesSociales } = props;
  const context = useContext(AppContext);
  let Periode = [];
    let { ClientConjoint } = props;
  if (props.ClientConjoint === "Conjoint" && context.state["PeriodeActuelle" + props.ClientConjoint].length === 0) {
    Periode = context.state["PeriodeActuelle"][0];
  } else {
    Periode = context.state["PeriodeActuelle" + props.ClientConjoint][0];
    ClientConjoint="";
  }
  if (Periode === undefined) return;

  // Icon style function for CAVP
  const getIconStyle = (type) => {
    switch (type) {
      case 'maladie':
        return { backgroundColor: '#e3f2fd', color: '#1976d2' };
      case 'famille':
        return { backgroundColor: '#f3e5f5', color: '#7b1fa2' };
      case 'ij':
        return { backgroundColor: '#e8f5e8', color: '#388e3c' };
      case 'prevoyance':
        return { backgroundColor: '#fff3e0', color: '#f57c00' };
      case 'retraite':
        return { backgroundColor: '#fce4ec', color: '#c2185b' };
      case 'retraite_comp':
        return { backgroundColor: '#fff8e1', color: '#f57c00' };
      case 'formation':
        return { backgroundColor: '#e0f2f1', color: '#00695c' };
      case 'urps':
        return { backgroundColor: '#f1f8e9', color: '#689f38' };
      case 'csg':
        return { backgroundColor: '#e8eaf6', color: '#3f51b5' };
      default:
        return { backgroundColor: '#f5f5f5', color: '#757575' };
    }
  };

  return (
    <>
      <div className="cotisations-container">
        <div className="cotisations-header cavp-layout">
          <div className="header-column"></div>
          <div className="header-column">Type de cotisation</div>
          <div className="header-column">Assiette</div>
          <div className="header-column">Taux</div>
          <div className="header-column">Cotisation</div>
          <div className="header-column">Part CPAM</div>
          <div className="header-column">Montant dû</div>
        </div>
        
        <div className="cotisations-list-container">
          
          <div className="cotisations-card light-title cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={{ backgroundColor: '#f8fafc', color: '#4f46e5' }}
            >
              📊
            </div>
            <div className="card-column">Cotisations {props.Prenom}</div>
            <div className="card-column"></div>
            <div className="card-column"></div>
            <div className="card-column"></div>
            <div className="card-column"></div>
            <div className="card-column"></div>
          </div>
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('maladie')}
            >
              🏥
            </div>
            <div className="card-column">Assurance maladie tranche 1</div>
            <div className="card-column">{DetailCotisations?.assiette_assurance_maladie}</div>
            <div className="card-column">{DetailCotisations?.taux_assurance_maladie}</div>
            <div className="card-column">{DetailCotisations?.assurance_maladie}</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.assurance_maladie}</div>
          </div>
          
          {DetailCotisations?.assurance_maladie2 !== "0 €" && (
            <div className="cotisations-card cavp-layout">
              <div 
                className="cotisations-card-icon" 
                style={getIconStyle('maladie')}
              >
                🏥
              </div>
              <div className="card-column">Assurance maladie tranche 2</div>
              <div className="card-column">{DetailCotisations?.assiette_assurance_maladie2}</div>
              <div className="card-column">{DetailCotisations?.taux_assurance_maladieT2}</div>
              <div className="card-column">{DetailCotisations?.assurance_maladie2}</div>
              <div className="card-column">-</div>
              <div className="card-column">{DetailCotisations?.assurance_maladie2}</div>
            </div>
          )}
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('famille')}
            >
              👨‍👩‍👧‍👦
            </div>
            <div className="card-column">Allocations familiales</div>
            <div className="card-column">{DetailCotisations?.assiette_allocation_familiale}</div>
            <div className="card-column">{DetailCotisations?.taux_allocation_familiale}</div>
            <div className="card-column">{DetailCotisations?.allocation_familiale}</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.allocation_familiale}</div>
          </div>
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('ij')}
            >
              💊
            </div>
            <div className="card-column">Indemnités journalières</div>
            <div className="card-column">{DetailCotisations?.assiette_ij_cpam}</div>
            <div className="card-column">{DetailCotisations?.taux_ij_cpam}</div>
            <div className="card-column">{DetailCotisations?.ij_cpam}</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.ij_cpam}</div>
          </div>
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('prevoyance')}
            >
              🦽
            </div>
            <div className="card-column">Invalidité / Décès</div>
            <div className="card-column">-</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.prevoyance}</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.prevoyance}</div>
          </div>
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('retraite')}
            >
              ☀️
            </div>
            <div className="card-column">Retraite de base tranche 1</div>
            <div className="card-column">{DetailCotisations?.assiette_retraite_de_base1}</div>
            <div className="card-column">{DetailCotisations?.taux_retraite_de_base1}</div>
            <div className="card-column">{DetailCotisations?.retraite_de_base1}</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.retraite_de_base1}</div>
          </div>
          
          {DetailCotisations?.retraite_de_base2 !== "0 €" && (
            <div className="cotisations-card cavp-layout">
              <div 
                className="cotisations-card-icon" 
                style={getIconStyle('retraite')}
              >
                ☀️
              </div>
              <div className="card-column">Retraite de base tranche 2</div>
              <div className="card-column">{DetailCotisations?.assiette_retraite_de_base2}</div>
              <div className="card-column">{DetailCotisations?.taux_retraite_de_base2}</div>
              <div className="card-column">{DetailCotisations?.retraite_de_base2}</div>
              <div className="card-column">-</div>
              <div className="card-column">{DetailCotisations?.retraite_de_base2}</div>
            </div>
          )}
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('retraite_comp')}
            >
              🌴
            </div>
            <div className="card-column">Retraite complémentaire en répartition</div>
            <div className="card-column">-</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.retraite_complementaire_repartition}</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.retraite_complementaire_repartition}</div>
          </div>
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('retraite_comp')}
            >
              🌴
            </div>
            <div className="card-column">Retraite complémentaire en capitalisation</div>
            <div className="card-column">-</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.retraite_complementaire_capi}</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.retraite_complementaire_capi}</div>
          </div>
          
          {Periode["ConventionneCavp" + ClientConjoint] === "oui" && (
            <>
              <div className="cotisations-card cavp-layout">
                <div 
                  className="cotisations-card-icon" 
                  style={getIconStyle('retraite_comp')}
                >
                  🌴
                </div>
                <div className="card-column">Retraite supplémentaire forfaitaire PCV</div>
                <div className="card-column">-</div>
                <div className="card-column">-</div>
                <div className="card-column">{DetailCotisations?.asv_forfaitaire}</div>
                <div className="card-column">{DetailCotisations?.asv_forfaitaire_Cpam}</div>
                <div className="card-column">{DetailCotisations?.asv_forfaitaire_restant}</div>
              </div>
              
              <div className="cotisations-card cavp-layout">
                <div 
                  className="cotisations-card-icon" 
                  style={getIconStyle('retraite_comp')}
                >
                  🌴
                </div>
                <div className="card-column">Retraite supplémentaire proportionnelle PCV</div>
                <div className="card-column">{DetailCotisations?.assiette_asv_proportionnelle}</div>
                <div className="card-column">{DetailCotisations?.taux_AsvPp}</div>
                <div className="card-column">{DetailCotisations?.asv_proportionnelle}</div>
                <div className="card-column">{DetailCotisations?.asv_proportionnelle_Cpam}</div>
                <div className="card-column">{DetailCotisations?.asv_proportionnelle_restant}</div>
              </div>
            </>
          )}
          
          <div className="cotisations-card light-title cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={{ backgroundColor: '#f8fafc', color: '#4f46e5' }}
            >
              📊
            </div>
            <div className="card-column" style={{ gridColumn: '2 / 7' }}>
              Cotisations sociales obligatoires <span style={{ fontSize: "12px" }}>&nbsp;(hors formation et CSG-CRDS)</span>
            </div>
            <div className="card-column">
              {applyFormat(DetailCSG?.ChargesSocialesObligatoire, "uint", { thousands: " ", decimal: ",", unit: " €" })}
            </div>
          </div>
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('formation')}
            >
              🎓
            </div>
            <div className="card-column">Formation professionnelle</div>
            <div className="card-column">{DetailCotisations?.assiette_formation_professionnelle}</div>
            <div className="card-column">{DetailCotisations?.taux_formation_professionnelle}</div>
            <div className="card-column">{DetailCotisations?.formation_professionnelle}</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.formation_professionnelle}</div>
          </div>
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('urps')}
            >
              🏛️
            </div>
            <div className="card-column">Contribution URPS</div>
            <div className="card-column">{DetailCotisations?.assiette_contribution_urps}</div>
            <div className="card-column">{DetailCotisations?.taux_Urps}</div>
            <div className="card-column">{DetailCotisations?.contribution_urps}</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.contribution_urps}</div>
          </div>
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('csg')}
            >
              💰
            </div>
            <div className="card-column">CSG déductible</div>
            <div className="card-column">{applyFormat(DetailCSG?.assiette_csg, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.TauxCSGDeductible, "ufloat", { thousands: " ", decimal: ",", precision: 2, unit: "%" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.csg_deductible, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            <div className="card-column">-</div>
            <div className="card-column">{applyFormat(DetailCSG?.csg_deductible, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
          
          <div className="cotisations-card cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={getIconStyle('csg')}
            >
              💰
            </div>
            <div className="card-column">CSG non déductible + CRDS</div>
            <div className="card-column">{applyFormat(DetailCSG?.assiette_csg, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.TauxCSGNonDeductible, "ufloat", { thousands: " ", decimal: ",", precision: 2, unit: "%" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.csg_non_deductible, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            <div className="card-column">-</div>
            <div className="card-column">{applyFormat(DetailCSG?.csg_non_deductible, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
          
          {Number(DetailCSG?.csg_primes) > 0 && (
            <div className="cotisations-card cavp-layout">
              <div 
                className="cotisations-card-icon" 
                style={getIconStyle('csg')}
              >
                💰
              </div>
              <div className="card-column">CSG non déductible + CRDS sur épargne salariale</div>
              <div className="card-column">{applyFormat(DetailCSG?.assiette_csg_primes, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
              <div className="card-column">{applyFormat(DetailCSG?.TauxCSG, "ufloat", { thousands: " ", decimal: ",", precision: 2, unit: "%" })}</div>
              <div className="card-column">{applyFormat(DetailCSG?.csg_primes, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
              <div className="card-column">-</div>
              <div className="card-column">{applyFormat(DetailCSG?.csg_primes, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          )}
          
          <div className="cotisations-card light-title cavp-layout">
            <div 
              className="cotisations-card-icon" 
              style={{ backgroundColor: '#f8fafc', color: '#22c55e' }}
            >
              💰
            </div>
            <div className="card-column" style={{ gridColumn: '2 / 7' }}>
              Total des cotisations sociales
            </div>
            <div className="card-column">
              {applyFormat(TotalChargesSociales, "uint", { thousands: " ", decimal: ",", unit: " €" })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailCotisationsCavp;
